var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackPepper({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E7C26D;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#92827A;}\n\t.st3{fill:#654F41;}\n\t.st4{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.19,185.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.9,151.26,61.5,185.55,104.19,185.55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.25,85.52l-12.13,59.51h60.62l-12.13-59.51H85.25z M124.83,139.49h-21.4h-21.4h-2.44l9.95-48.82h13.83h0.12 h13.83l9.95,48.82H124.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.16,81.19H81.71l-13.89,68.19h71.24L125.16,81.19z M133.74,145.03H73.12l12.13-59.51h36.37L133.74,145.03z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.38,79.14c0-9.52-7.75-17.27-17.27-17.27h-5.37c-9.52,0-17.27,7.75-17.27,17.27v2.17h39.91V79.14z  M114.7,71.13c1.04,0,1.89,0.85,1.89,1.89c0,1.04-0.85,1.89-1.89,1.89c-1.04,0-1.89-0.85-1.89-1.89 C112.81,71.97,113.66,71.13,114.7,71.13z M112.85,68.2c0,1.04-0.85,1.89-1.89,1.89c-1.04,0-1.89-0.85-1.89-1.89 c0-1.04,0.85-1.89,1.89-1.89C112,66.31,112.85,67.15,112.85,68.2z M107.16,71.13c1.04,0,1.89,0.85,1.89,1.89 c0,1.04-0.85,1.89-1.89,1.89c-1.04,0-1.89-0.85-1.89-1.89C105.26,71.97,106.11,71.13,107.16,71.13z M103.43,70.09 c-1.04,0-1.89-0.85-1.89-1.89c0-1.04,0.85-1.89,1.89-1.89c1.04,0,1.89,0.85,1.89,1.89C105.32,69.24,104.48,70.09,103.43,70.09z  M94.05,73.02c0,1.04-0.85,1.89-1.89,1.89c-1.04,0-1.89-0.85-1.89-1.89c0-1.04,0.85-1.89,1.89-1.89 C93.2,71.13,94.05,71.97,94.05,73.02z M95.96,66.31c1.04,0,1.89,0.85,1.89,1.89c0,1.04-0.85,1.89-1.89,1.89 c-1.04,0-1.89-0.85-1.89-1.89C94.07,67.15,94.92,66.31,95.96,66.31z M99.63,71.13c1.04,0,1.89,0.85,1.89,1.89 c0,1.04-0.85,1.89-1.89,1.89c-1.04,0-1.89-0.85-1.89-1.89C97.73,71.97,98.58,71.13,99.63,71.13z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 103.43,
    cy: 68.2,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.96,
    cy: 68.2,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 110.96,
    cy: 68.2,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.63,
    cy: 73.02,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 92.16,
    cy: 73.02,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 107.16,
    cy: 73.02,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 114.7,
    cy: 73.02,
    r: 1.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.49,90.67h-0.12H89.54l-9.95,48.82h2.44h21.4h21.4h2.44l-9.95-48.82H103.49z M98.98,99.18 c0.62,0,1.12,0.5,1.12,1.12c0,0.62-0.5,1.12-1.12,1.12c-0.62,0-1.12-0.5-1.12-1.12C97.85,99.68,98.36,99.18,98.98,99.18z  M97.29,110.65c0,0.68-0.55,1.23-1.23,1.23c-0.68,0-1.23-0.55-1.23-1.23c0-0.68,0.55-1.23,1.23-1.23 C96.74,109.42,97.29,109.97,97.29,110.65z M94.42,103.35c0,0.66-0.53,1.19-1.19,1.19c-0.66,0-1.19-0.53-1.19-1.19 c0-0.66,0.53-1.19,1.19-1.19C93.89,102.16,94.42,102.69,94.42,103.35z M92.41,94.92c0.57,0,1.02,0.46,1.02,1.02 c0,0.57-0.46,1.02-1.02,1.02c-0.57,0-1.02-0.46-1.02-1.02C91.39,95.38,91.85,94.92,92.41,94.92z M90.06,107.75 c0.57,0,1.02,0.46,1.02,1.02c0,0.57-0.46,1.02-1.02,1.02c-0.57,0-1.02-0.46-1.02-1.02C89.04,108.21,89.5,107.75,90.06,107.75z  M86.79,134.25c-0.57,0-1.02-0.46-1.02-1.02s0.46-1.02,1.02-1.02c0.57,0,1.02,0.46,1.02,1.02S87.36,134.25,86.79,134.25z  M89.02,119.41c-0.58,0-1.04-0.47-1.04-1.04c0-0.58,0.47-1.04,1.04-1.04c0.58,0,1.04,0.47,1.04,1.04 C90.06,118.95,89.6,119.41,89.02,119.41z M92.16,129.74c-1.04,0-1.89-0.85-1.89-1.89c0-1.04,0.85-1.89,1.89-1.89 c1.04,0,1.89,0.85,1.89,1.89C94.05,128.89,93.2,129.74,92.16,129.74z M95.62,119.92c-0.78,0-1.4-0.63-1.4-1.4 c0-0.78,0.63-1.4,1.4-1.4c0.78,0,1.4,0.63,1.4,1.4C97.02,119.3,96.39,119.92,95.62,119.92z M98.7,134.92 c-0.78,0-1.42-0.63-1.42-1.42c0-0.78,0.63-1.42,1.42-1.42c0.78,0,1.42,0.63,1.42,1.42C100.12,134.29,99.48,134.92,98.7,134.92z  M99.44,127.11c-1.08,0-1.95-0.87-1.95-1.95s0.87-1.95,1.95-1.95c1.08,0,1.95,0.87,1.95,1.95S100.52,127.11,99.44,127.11z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 92.16,
    cy: 127.85,
    r: 1.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.02,117.33c-0.58,0-1.04,0.47-1.04,1.04c0,0.58,0.47,1.04,1.04,1.04c0.58,0,1.04-0.47,1.04-1.04 C90.06,117.79,89.6,117.33,89.02,117.33z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 96.06,
    cy: 110.65,
    r: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.98,101.42c0.62,0,1.12-0.5,1.12-1.12c0-0.62-0.5-1.12-1.12-1.12c-0.62,0-1.12,0.5-1.12,1.12 C97.85,100.92,98.36,101.42,98.98,101.42z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 93.23,
    cy: 103.35,
    r: 1.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 86.79,
    cy: 133.23,
    r: 1.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.7,132.09c-0.78,0-1.42,0.63-1.42,1.42c0,0.78,0.63,1.42,1.42,1.42c0.78,0,1.42-0.63,1.42-1.42 C100.12,132.72,99.48,132.09,98.7,132.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.44,123.2c-1.08,0-1.95,0.87-1.95,1.95s0.87,1.95,1.95,1.95c1.08,0,1.95-0.87,1.95-1.95 S100.52,123.2,99.44,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.62,117.12c-0.78,0-1.4,0.63-1.4,1.4c0,0.78,0.63,1.4,1.4,1.4c0.78,0,1.4-0.63,1.4-1.4 C97.02,117.74,96.39,117.12,95.62,117.12z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 90.06,
    cy: 108.77,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 92.41,
    cy: 95.94,
    r: 1.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105,109.37c-0.02-1.45,0.6-2.9,1.67-3.89"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPepper);
export default __webpack_public_path__ + "static/media/Black_pepper.e39765a85406eb01c51fc2fa36f0e2a1.svg";
export { ForwardRef as ReactComponent };